import axios from 'axios'
import router from '../../router'
import AuthDataService from '../../service/AuthDataService'
const loggedInUser = JSON.parse(localStorage.getItem('pt_user'))

const initialState = {
    loading: false,
    user: loggedInUser ? loggedInUser : null,
    login: {
        email: null,
        password: null,
    },
}

export default {
    namespaced: true,
    state: { ...initialState },
    actions: {
        async handleLogin({ state, commit, dispatch }) {
            try {
                commit('setLoading', true)
                const resp = await axios.post(`${process.env.VUE_APP_API_URL}auth`, { ...state.login })
                await commit('setLoggedInUser', resp.data.payload)
                await commit('setLoading', false)
                await dispatch('app/fetchAppSettings', {}, { root: true })
                if (resp.data.payload.user.role !== 'customer') {
                    await router.push({ name: 'user-list' })
                } else {
                    await router.push({ name: 'data-analytics-view' })
                }
                commit('setLoading', false)
            } catch (e) {
                console.log(e.response.status)
                await commit('setLoading', false)
                if (e.response.status === 400) {
                    dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: 'Wrong email or password!',
                            type: 'red',
                        },
                        { root: true }
                    )
                } else {
                    dispatch(
                        'app/showSnackbar',
                        {
                            bool: true,
                            message: 'You are not authorized!',
                            type: 'red',
                        },
                        { root: true }
                    )
                }
            }
        },
        async logOut({ commit }) {
            const resp = await AuthDataService.logout()
            if (resp.status === 200) {
                localStorage.removeItem('pt_user')
                commit('resetUser')
                await router.push({ name: 'login' })
            }
        },
    },
    mutations: {
        setLoggedInUser(state, data) {
            state.user = data.user
            localStorage.setItem('pt_user', JSON.stringify(data.user))
        },
        setLoginParam(state, payload) {
            const { param, value } = payload
            state.login[param] = value
        },
        setLoading(state, bool) {
            state.loading = bool
        },
        resetUser(state) {
            state.user = null
        },
    },
    getters: {
        loggedIn: state => {
            return !!state.user
        },
        isAdmin(state) {
            const userRole = state.user?.role || null
            return userRole && ['admin', 'super_admin'].includes(userRole)
        },
    },
}
